import { render, staticRenderFns } from "./sideContents.vue?vue&type=template&id=0aced10e&scoped=true&"
import script from "./sideContents.vue?vue&type=script&lang=js&"
export * from "./sideContents.vue?vue&type=script&lang=js&"
import style0 from "./sideContents.vue?vue&type=style&index=0&id=0aced10e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aced10e",
  null
  
)

export default component.exports